<template>
  <v-dialog :value="value" max-width="440" persistent>
    <v-card dark class="wcd-card rounded-xl">
      <!-- Header -->
      <div class="wcd-header">
        <div class="d-flex align-center" style="gap: 10px">
          <div class="wcd-icon" :style="{ background: data?.template.color || '#4CAF50' }">
            <v-icon small color="white">{{ data?.template.icon || "mdi-calendar" }}</v-icon>
          </div>
          <div>
            <div class="wcd-title">{{ data?.template.title }}</div>
            <div class="wcd-subtitle">{{ data?.col.firstName }}</div>
          </div>
        </div>
        <v-btn icon x-small @click="$emit('input', false)" style="color: rgba(255, 255, 255, 0.3)">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pt-4 pb-2 overflow-visible">
        <!-- Time Row -->
        <div class="wcd-time-row">
          <div class="wcd-time-item">
            <div class="wcd-time-label">Start</div>
            <v-text-field
              v-if="data"
              v-model="localStart"
              type="time"
              dense
              solo
              flat
              dark
              hide-details
              background-color="rgba(255,255,255,0.04)"
              class="wcd-time-input"></v-text-field>
          </div>
          <div class="wcd-time-item" v-if="data && data.template.type === 'appointment'">
            <div class="wcd-time-label">Dauer</div>
            <v-text-field
              v-model.number="localDuration"
              type="number"
              suffix="Min"
              dense
              solo
              flat
              dark
              hide-details
              background-color="rgba(255,255,255,0.04)"
              class="wcd-time-input"></v-text-field>
          </div>
          <div class="wcd-time-item">
            <div class="wcd-time-label">Ende</div>
            <div class="wcd-time-result">{{ calculatedEnd }}</div>
          </div>
        </div>

        <!-- Customer Search -->
        <div v-if="data?.template.requiresCustomer" class="mt-4 relative" style="z-index: 1000">
          <div class="wcd-time-label mb-1">Kunde *</div>
          <user-search
            :value="selectedCustomer"
            @update="updateCustomer"
            return-object
            ignore-rights
            label="Kunden suchen..."
            dark
            outlined
            dense
            :menu-props="{ zIndex: 9999, offsetY: true }"></user-search>
        </div>

        <!-- Notes -->
        <v-textarea
          v-if="data"
          v-model="localDesc"
          label="Notiz (Optional)"
          outlined
          dense
          rows="2"
          dark
          hide-details
          class="mt-4"
          style="font-size: 0.85rem"></v-textarea>
      </v-card-text>

      <v-card-actions class="px-5 pb-4 pt-2">
        <v-spacer></v-spacer>
        <v-btn text small @click="$emit('input', false)" style="color: rgba(255, 255, 255, 0.4); text-transform: none">Abbrechen</v-btn>
        <v-btn small depressed class="wcd-save-btn" @click="save" :disabled="data?.template.requiresCustomer && !selectedCustomer">
          <v-icon left x-small>mdi-check</v-icon> Erstellen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UserSearch from "@/components/userSearch"
import moment from "moment"

export default {
  name: "WorkCalendarDropDialog",
  components: { UserSearch },
  props: ["value", "data"],
  data() {
    return {
      localStart: "",
      localDuration: 60,
      localDesc: "",
      selectedCustomer: null,
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        if (val) {
          this.localStart = val.time
          this.localDuration = val.template.duration || 60
          this.localDesc = val.description
          this.selectedCustomer = null
        }
      },
    },
  },
  computed: {
    calculatedEnd() {
      if (!this.localStart) return "-"
      return moment(this.localStart, "HH:mm").add(this.localDuration, "minutes").format("HH:mm")
    },
  },
  methods: {
    updateCustomer(value) {
      this.selectedCustomer = value
    },
    save() {
      this.$emit("save", {
        ...this.data,
        time: this.localStart,
        duration: this.localDuration,
        description: this.localDesc,
        customer: this.selectedCustomer,
      })
    },
  },
}
</script>

<style scoped>
.wcd-card {
  background: rgba(22, 22, 22, 0.98) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
}
.wcd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 12px;
}
.wcd-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wcd-title {
  font-size: 1rem;
  font-weight: 700;
  color: white;
}
.wcd-subtitle {
  font-size: 0.7rem;
  color: rgba(255, 255, 255, 0.4);
}

/* Time Row */
.wcd-time-row {
  display: flex;
  gap: 10px;
}
.wcd-time-item {
  flex: 1;
}
.wcd-time-label {
  font-size: 0.6rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.wcd-time-input >>> input {
  text-align: center;
  font-weight: 700;
  font-size: 0.85rem;
}
.wcd-time-input >>> .v-input__slot {
  border-radius: 8px !important;
  min-height: 36px !important;
}
.wcd-time-result {
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: 700;
  color: #66bb6a;
  background: rgba(76, 175, 80, 0.08);
  border-radius: 8px;
}

/* Save Button */
.wcd-save-btn {
  background: linear-gradient(135deg, #4caf50, #2e7d32) !important;
  color: white !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
}
.overflow-visible {
  overflow: visible !important;
}
</style>
